<template>
  <div class="cont" id="cont4">
    <div class="inner">
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
        style="height:35px;width:168px;margin-left:95px;margin-bottom:12px"
        :src="require('@/assets/image/home/home4/img1.png')"
        :fit="fit"
      ></el-image>

      <router-link :to="{ name: 'BrakepadsClassroom'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:137px;margin-left:80px;margin-bottom:9px"
          :src="require('@/assets/image/home/home4/img2.png')"
          :fit="fit"
      ></el-image>
      </router-link>

      <router-link :to="{ name: 'BrakediscClassroom'  }"> 
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:137px;margin-left:66px;margin-bottom:10px"
          :src="require('@/assets/image/home/home4/img3.png')"
          :fit="fit"
        ></el-image>
      </router-link>

      <router-link :to="{ name: 'BrakeoilClassroom'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:137px;margin-left:52px;margin-bottom:9px"
          :src="require('@/assets/image/home/home4/img4.png')"
          :fit="fit"
        ></el-image>
      </router-link>

      <router-link :to="{ name: 'OtherClassroom'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:87px;margin-left:37px;margin-bottom:54px;display:block"
          :src="require('@/assets/image/home/home4/img5.png')"
          :fit="fit"
        ></el-image>
      </router-link>


      <router-link :to="{ name: 'BrakeClassroom'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
          style="height:29px;width:137px;margin-left:0px;margin-bottom:0px;"
          :src="require('@/assets/image/home/home4/img6.png')"
          :fit="fit"
        ></el-image>
      </router-link>

    </div>
  </div>
</template>

<script>
export default {
  name: "ContFour",
  data() {
    return {
      fit: "cover",
      animate: false,
      screenHeight: window.innerHeight || document.documentElement.clientHeight
    };
  },
  mounted() {
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    var topPos = document.getElementById("cont4").offsetTop;
    if (scrollTop + this.screenHeight > topPos) {
      this.animate = true;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var topPos = document.getElementById("cont4").offsetTop;
      if (scrollTop + this.screenHeight > topPos) {
        this.animate = true;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  height: 368px;
  background-color: pink;
  color: #fff;
  margin: 0 auto;
  background: url('~@/assets/image/home/home4/bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.inner {
  position: absolute;
  width: 263px;
  height: 217px;
  left: 81px;
  top: 62px;
}
</style>